export const selectedMeetingTypeSelector = (state) => state.finishStep.selectedMeetingType;
export const registerDataSelector = (state) => state.finishStep.registerData;
export const isRegisteringSelector = (state) => state.finishStep.isRegistering;
